export default __webpack_public_path__ + "static/media/H1016.2.84c0ee22.mp3";